import type { JSX } from 'react';
import type { SortState } from '@/shared/types/table-filters.types';
import { SuperAdminCard } from './SuperAdminCard';
import { SuperAdminTable } from './SuperAdminTable';
import type { SuperAdmin } from '../types/super-admin.types';

interface SuperAdminListProps {
  superAdmins: SuperAdmin[];
  isLoading: boolean;
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  currentUserId?: string | undefined;
  onEdit: (superAdmin: SuperAdmin) => void;
}

/** Desktop table and mobile cards render the same already filtered/sorted super admins. */
export function SuperAdminList({
  superAdmins,
  isLoading,
  sort,
  onToggleSort,
  currentUserId,
  onEdit,
}: SuperAdminListProps): JSX.Element {
  if (isLoading) {
    return <div className="text-center py-8 text-muted-foreground">Loading super admins...</div>;
  }

  if (superAdmins.length === 0) {
    return <div className="text-center py-8 text-muted-foreground">No super admins found</div>;
  }

  return (
    <>
      {/* Desktop: Table view */}
      <div className="hidden md:block">
        <SuperAdminTable
          superAdmins={superAdmins}
          sort={sort}
          onToggleSort={onToggleSort}
          currentUserId={currentUserId}
          onEdit={onEdit}
        />
      </div>

      {/* Mobile: Card view */}
      <div className="grid gap-4 md:hidden">
        {superAdmins.map((superAdmin) => (
          <SuperAdminCard
            key={superAdmin.id}
            superAdmin={superAdmin}
            isCurrentUser={superAdmin.id === currentUserId}
            onEdit={onEdit}
          />
        ))}
      </div>
    </>
  );
}
